import React, { useState } from "react";
import { Info, InfoOutlined } from "@mui/icons-material";
import {
  Typography,
  IconButton,
  Popover,
  Button,
  Dialog,
  DialogContent,
  Divider,
  DialogActions,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { IoIosInformationCircle } from "react-icons/io";
import usePrimaryColor from "../../hooks/usePrimaryColor";

export default function UserHint({
  hint,
  appendString = "",
  color = "GrayText",
  iconOnly = false,
  maxWidth = "70%",
  sx,
  ...rest
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const iconColor = usePrimaryColor();
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  if (!hint) {
    return null;
  }

  return iconOnly ? (
    <>
      <IconButton size="small" onClick={handleOpen} title={t("MoreInfo")} sx={sx}>
        <InfoOutlined fontSize="small" />
      </IconButton>
      <Dialog
        open={open}
        fullWidth
        onClose={handleClose}
        maxWidth={"xs"}
        PaperProps={{ sx: { borderRadius: "18px" } }}
      >
        <Stack p={2} justifyContent={"center"} alignItems={"center"}>
          <IoIosInformationCircle color={iconColor} size={100} />
        </Stack>
        <DialogContent sx={{ textAlign: "center" }}>
          <Typography sx={{ p: 1 }}>{t(hint) + t(appendString)}</Typography>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button variant="contained" onClick={handleClose}>
            {t("OK")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : (
    <Typography
      color={color}
      sx={sx}
      textAlign={{ sm: "center", xs: "center", md: "left" }}
      {...rest}
    >
      <InfoOutlined
        fontSize="small"
        sx={{ verticalAlign: "middle", marginRight: 0.5 }}
      />
      <small>{t(hint) + t(appendString)}</small>
    </Typography>
  );
}
